export const API_NODE_BASE =
  process.env.REACT_APP_API_NODE_BASE_URL ?? process.env.REACT_APP_API_BASE_URL;

export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
// KOOB cloud map style (KD-3753); unset falls back to Google's DEMO_MAP_ID.
export const GOOGLE_MAPS_MAP_ID = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID;

export const HTML_TO_PDF_API_URL =
  process.env.REACT_APP_HTML_TO_PDF_API_URL ??
  'https://html-to-pdf.koob.tech/html-to-pdf';
export const HTML_TO_PDF_API_KEY = process.env.REACT_APP_HTML_TO_PDF_API_KEY;

export const KOEDIA = 'KOEDIA';
export const RAKUTEN = 'RAKUTEN';

export const DEFAULT_LOCAL = 'en';

export const REACT_QUILL_INIT_CONTENT = '<p><br></p>';
export const REACT_QUILL_EMPTY_CONTENT = '<p></p>';
export const PER_PAGE_FOR_LIST = 12;
export const PER_PAGE_FOR_CATALOG = 12;

export const HOTELS_CATALOG_SCROLL_KEY = 'koob-to-hotels-catalog-scroll';
export const EXPERIENCES_CATALOG_SCROLL_KEY =
  'koob-to-experiences-catalog-scroll';
